import AxiosInstance from "../axiosInstance"; 

export const getSpecialitiesList = async (not_used_cached) => {
    const cached = localStorage.getItem("SpecialitiesList");
  
    if ( !not_used_cached && cached) {
      try {
        const storedList = JSON.parse(cached);
        if (storedList.length > 0) {
          return storedList;
        }
      } catch (e) {
        console.error("Error parsing SpecialitiesList from localStorage", e);
      }
    }
  
    const transformData = (items) =>
      items
        .map(({ id, name }) => ({
          value: id,
          label: name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
  
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_ALL_SPECIALITIES}`
      );
      const list = transformData(response.data?.data?.specialities || []);

      console.log("SpecialitiesList fetched:", list);
      
      localStorage.setItem("SpecialitiesList", JSON.stringify(list));
      return list;
    } catch (error) {
      console.error("Failed to fetch SpecialitiesList:", error?.message);
      return [];
    }
  };
  
  